export let medioAmbiente: any[] = [
  {
    id: 1,
    nombre: 'Estudios de Evaluación de Impacto Ambiental(EEIA).',
    desc: 'Estudio destinado a identificar y evaluar los potenciales impactos positivos y negativos que pueda causar la implementación, operación, futuro inducido, mantenimiento y abandono de un proyecto, obra o actividad, con el fin de establecer las correspondientes medidas para evitar, mitigar o controlar aquellos que sean negativos e incentivar los positivos.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 2,
    nombre: 'Auditoria Línea Base Ambiental(ALBA).',
    desc: 'Reporta de manera detallada el lugar donde va iniciar su Actividad, Obra o Proyecto (AOP) minero, a través del documento de línea base, evitará que se le haga responsable de las condiciones ambientales previas del lugar.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 3,
    nombre: 'Fichas Ambientales (FA).',
    desc: 'Documento técnico que marca el inicio del proceso de Evaluación de Impacto Ambiental, el mismo que se constituye en instrumento para la determinación de la Categoría de EElA, con ajuste al Art. 25 de la LEY. Este documento, que tiene categoría de declaración jurada, incluye información sobre el proyecto, obra o actividad, la identificación de impactos clave y la identificación de la posible solución para los impactos negativos.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 4,
    nombre: 'Formulario de Solicitud de Certificados de dispensación(FSCD).',
    desc: '',
    img: ''
  },
  {
    id: 5,
    nombre: 'Programas de Prevención y Mitigación (PPM).',
    desc: 'Consiste en formular un conjunto de medidas de prevención y mitigación de los impactos ambientales significativos, de manera que sus efectos en el ambiente sean neutralizados o reducidos hasta cumplir con la normativa ambiental vigente y las buenas prácticas ambientales.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 6,
    nombre: 'Programas de Aplicación y Seguimiento Ambiental (PASA).',
    desc: '',
    img: ''
  },
  {
    id: 7,
    nombre: 'Manifiestos Ambientales (MA).',
    desc: 'Instrumento mediante el cual el REPRESENTANTE LEGAL de un proyecto, obra o actividad en proceso de implementación, operación o etapa de abandono a la puesta en vigencia del presente reglamento informa a la Autoridad Ambiental Competente, del estado ambiental en que se encuentra el mismo y propone un plan de adecuación ambiental, si corresponde.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 8,
    nombre: 'Planes de Adecuación Ambiental (PAA).',
    desc: '',
    img: ''
  },
  {
    id: 9,
    nombre: 'Informe de Monitoreo Ambiental (IMA).',
    desc: 'Sistema de seguimiento continúo de la calidad ambiental a través de la observación, medidas y evaluaciones de una o más de las condiciones ambientales con propósitos definidos.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 10,
    nombre: 'Licencias para Actividades con Sustamcias Peligrosas (LASP).',
    desc: 'Toda persona natural o colectiva, pública o privada que realice actividades con sustancias peligrosas, deberá tramitar la obtención de su LASP ante la Autoridad Ambiental Competente Nacional (AACN) o Autoridad Ambiental Competente Departamental (AACD) según corresponda Serán consideradas sustancias peligrosas aquellas que presenten o conlleven, entre otras, las siguientes características intrínsecas: corrosividad, explosividad, inflamabilidad, patogenicidad o bioinfecciosidad, radioactividad, reactividad y toxicidad, de acuerdo a pruebas estándar',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 11,
    nombre: 'Registros Ambientas Industriales (RAI).',
    desc: 'Marca el inicio del proceso de regulación ambiental de las actividades del sector industrial manufacturero, en cumplimiento de las disposiciones del reglamento Ambiental para el sector industrial manufacturero',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 12,
    nombre: 'Descripción de Proyectos (DP`).',
    desc: 'Documento donde se establecen objetivos, acciones, recursos, presupuestos de un determinado proyecto.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 13,
    nombre: 'Manifiestos Ambientales Industriales (MAI).',
    desc: 'Instrumento mediante el cual el REPRESENTANTE LEGAL de un proyecto, obra o actividad en proceso de implementación, operación o etapa de abandono a la puesta en vigencia del presente reglamento informa a la Autoridad Ambiental Competente, del estado ambiental en que se encuentra el mismo y propone un plan de adecuación ambiental, si corresponde.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 14,
    nombre: 'Plan de Manejo Ambiental (PMA).',
    desc: 'Es el instrumento producto de una evaluación ambiental que, de manera detallada, establece las acciones que se implementarán para prevenir, mitigar, rehabilitar o compensar los impactos negativos que cause el desarrollo de un proyecto, obra o actividad. Incluye los planes de relaciones comunitarias, monitoreo, contingencia y abandono según la naturaleza del proyecto, obra o actividad.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 15,
    nombre: 'Informes Ambientales Anuales (IAA).',
    desc: 'Para la supervisión de las actividades de hidrocarburos, se ha establecido la obligación de presentar anualmente, antes del 31 de marzo, un informe correspondiente al ejercicio anterior, dando cuenta detallada y sustentadamente sobre el cumplimiento de las normas y disposiciones del reglamento, sus normas complementarias y las regulaciones ambientales que le son aplicables. Para tal fin, en el propio reglamento se han aprobado términos de referencia que detallan la forma como deberá ser presentada la información al OSINERGMIN',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 16,
    nombre: 'Análisis de Riesgos Ambientales (ARI).',
    desc: 'Documento relativo al proceso de identificación del peligro y estimación del riesgo que puede formar parte del EElA y del MA. En adición a los aspectos cualitativos de identificación del peligro, el análisis de riesgo incluye una descripción cuantitativa del riesgo en base a las técnicas reconocidas de evaluación de riesgo.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 17,
    nombre: 'Planes de Contingencia Ambiental (PC).',
    desc: 'Presenta una estructura estratégica y operativa que ayudara controlar una situación de emergencia y a minimizar sus consecuencias negativas. Garantiza la estabilidad y el funcionamiento  de los medicamentos sin tener cambios físicos ni químicos.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 18,
    nombre: 'Planes y manuales de gestión de Residuos Solidos.',
    desc: 'Se llama a todo el proceso que engloba las actividades necesarias para hacerse cargo de un residuo. La gestión de residuos comienza con la recogida de los mismos, su transporte hasta las instalaciones preparadas y su tratamiento intermedio o final. Este tratamiento puede ser el aprovechamiento del residuo o su eliminación.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 19,
    nombre: 'Planes y manuales de Uso Eficiente de Energia.',
    desc: 'Documentos que contienen manuales que tiene como objetivo reducir el consumo de energía. La eficiencia energética es el uso eficiente de la energía, de esta manera optimizar los procesos productivos y el empleo de la energía utilizando lo mismo o menos para producir más bienes y servicios. Dicho de otra manera, producir más con menos energía. No se trata de ahorrar luz, sino de iluminar mejor consumiendo menos electricidad.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 20,
    nombre: 'Planes y manuales de Uso Eficiente de Agua.',
    desc: 'Guias que contienen la  “gestión del uso eficiente de este recurso que debe basarse en un enfoque participativo, involucrando a usuarios, planificadores y los responsables de las decisiones a todos los niveles”.',
    img: 'assets/img/app/appimg5.png'
  },
  {
    id: 21,
    nombre: 'Capacitaciones en temas de Medio Ambiente.',
    desc: 'Se realizan capacitaciones ambientales con el objetivo de educar, concientizar, ampliar conocimiento  de los involucrados.',
    img: 'assets/img/app/appimg5.png'
  }
];



// WEBPACK FOOTER //
// G:/proyectos/website - IntergraMAI/webMai/src/assets/medioAmbiente.data.ts